<template>
    <div id="gallery-container" class="gallery-container">

        <view-header v-if="model.viewModel.renderType !== 'Mobile' && showHeader" :table="table" :view="view"
                     :parent-table="parentTable"
                     :parent-document="parentDocument"></view-header>

        <div class="row no-gutters mx-0 h-100">

            <app-config :view="view"></app-config>

            <div class="col-8 bg-light">

                <phone-container v-if="model.viewModel.renderType === 'Mobile'" :view="view">

                    <template v-slot:header>
                        <div class="d-flex justify-content-between p-2">
                            <div></div>
                            <div>{{view.name}}</div>
                            <div></div>
                        </div>
                    </template>

                    <gallery-grid-renderer :view="view" :view-model="model.viewModel" :layout="layout" :table="table"
                                           class="p-3" style="height: 600px; overflow-y: scroll;"
                                           :view-config="galleryConfig"></gallery-grid-renderer>

                    <mobile-tabs-container :view="view"  v-slot:tabNav></mobile-tabs-container>
                </phone-container>

                <gallery-grid-renderer v-else :view="view" :view-model="model.viewModel" :layout="layout"
                                       :table="table" :view-config="galleryConfig"></gallery-grid-renderer>
            </div>

            <layout-property-editor v-if="table && layout" class="bg-white"
                                    :view-model="model.viewModel" :layout="layout" :view="view"
                                    :table="table" :config="galleryConfig"></layout-property-editor>

        </div>
    </div>
</template>

<script>
    import ViewService from "../../services/ViewService";
    import SelectView from "../../components/SelectView.vue";
    import ViewHeader from "../ViewHeader.vue";
    import LayoutPropertyEditor from "../../editor/experimental/LayoutPropertyEditor.vue";
    import GalleryGridRenderer from "./GalleryGridRenderer.vue";
    import PhoneHeader from "../../components/PhoneHeader.vue";
    import PhoneContainer from "../../components/PhoneContainer.vue";
    import AppConfig from "../../editor/experimental/AppConfig.vue";
    import MobileTabsContainer from "../../editor/experimental/MobileTabsContainer.vue";

    export default {
        name: 'GalleryViewWithMobile',
        components: {
            MobileTabsContainer,
            AppConfig,
            PhoneContainer, PhoneHeader, GalleryGridRenderer, LayoutPropertyEditor, ViewHeader, SelectView},
        props: {
            view: Object,
            table: Object,
            parentTable: Object,
            parentDocument: Object,
            showHeader: {
                type: Boolean,
                default: true
            }
        },
        data() {
            return {
                model: webase.model,
                records: [],
                featuredImageField: null
            }
        },
        computed: {
            layout() {
                // if (!this.view.layout.gallery) {
                //     console.log('Initializing gallery')
                //     this.view.layout.gallery = {
                //         mobile: {
                //             columnCount: 2
                //         },
                //         desktop: {
                //             columnCount: 3
                //         }
                //     }
                // }

                return this.view.layout
            },
            galleryConfig() {
                return this.model.viewModel.renderType === 'Mobile' ? this.layout.gallery.mobile : this.layout.gallery.desktop
            },
            primaryField() {
                return webase.utils.table.getPrimaryField(this.table)
            },
            gridRows() {
                return webase.utils.array.listToGrid(this.records, this.columnCount)
            },
            attachment() {
                let field = webase.utils.table.getAttachmentField(this.table)
                return field
            },
            textField() {
                return webase.utils.table.getTextField(this.table)
            },
            selectField() {
                return webase.utils.table.getSelectField(this.table)
            }
        },
        mounted() {
            this.loadData()
            webase.eventDispatcher.on('viewUpdated', this.loadData)
            this.setFeaturedImage()
        },
        beforeUnmount() {
            webase.eventDispatcher.off('viewUpdated', this.loadData)
        },
        methods: {
            loadData() {
                let viewService = new ViewService()

                viewService.getData(this.view, this.table).then((response) => {
                    this.records = response
                }).catch((message) => {
                    console.log('error loading data from table')
                    console.log(message)
                })
            },
            fieldValue(document, field) {
                return document[field.index]
            },
            getFeaturedImage(record) {

                if (this.featuredImageField) {
                    let imageData = record[this.featuredImageField.index]

                    if (imageData) {
                        return imageData.url
                    }
                }


                let attachmentData = record[this.attachment.index]

                if (attachmentData === undefined || attachmentData === null || attachmentData.length === 0) {
                    return null
                }

                let firstAttachment = attachmentData[0]

                if (!webase.utils.table.isImage(firstAttachment)) {
                    return null
                }

                let featureImageUrl = firstAttachment.url
                // console.log(featureImageUrl)
                return featureImageUrl
            },
            detailsRoute(documentId) {

                if (webase.utils.table.hasDetailsView(this.table)) {
                    let detailsView = webase.utils.table.getDetailsView(this.table)
                    return {name: 'details-view', params: {view_id: detailsView.id, record_id: documentId}}
                }

                return {name: 'static-details', params: {table_id: this.table.id, record_id: documentId}}
            },
            setFeaturedImage() {
                if (this.view.layout.rows && this.view.layout.rows.length > 0) {
                    let firstRow = this.view.layout.rows[0]

                    if (firstRow.columns && firstRow.columns.length > 0) {
                        let firstColumn = firstRow.columns[0]

                        console.log(firstColumn)

                        if (firstColumn.value && firstColumn.value.length > 0) {
                            let firstComponent = firstColumn.value[0]

                            if (firstComponent.type === 'Field' && firstComponent.value.field_type === 'Image') {
                                this.featuredImageField = firstComponent.value
                                return
                            }
                        }
                    }
                }
            },
        }
    }
</script>